/* eslint-disable func-names */
/* eslint-disable no-unused-expressions */
export const parseOptions = undefined;

const WEBFLOW_PLAUSIBLE_CTA_IDS = ['StakeTraxx', 'ClaimMembershipPass'];

export const addNavbarEvent = () => {
  const wrapperElement = document.getElementsByClassName(
    'div-block-23-wrapper',
  );
  const navBarElement = document.getElementsByClassName('nav-division2');
  if (wrapperElement && wrapperElement.length) {
    wrapperElement[0].addEventListener('mouseenter', () => {
      navBarElement.length
        ? navBarElement[0].classList.add('nav-division2-hover')
        : '';
    });
    wrapperElement[0].addEventListener('mouseleave', () => {
      navBarElement.length
        ? navBarElement[0].classList.remove('nav-division2-hover')
        : '';
    });
  }
};

const getWindowObj = () => {
  return window as any;
};

const toggleLearnMoreClass = () => {
  const modalElement: any = document.getElementsByClassName('popup-crousel');
  if (modalElement && modalElement.length) {
    modalElement[0].style.display =
      modalElement[0].style.display === 'none' ? 'block' : 'none';
  }
};

const addEventForPlausibleClick = () => {
  const element = document.getElementById(WEBFLOW_PLAUSIBLE_CTA_IDS[0]);
  if (element) {
    element.onclick = function () {
      if (getWindowObj()) {
        getWindowObj().plausible('Stake Traxx Clicked');
      }
    };
  }
  const element2 = document.getElementById(WEBFLOW_PLAUSIBLE_CTA_IDS[1]);
  if (element2) {
    element2.onclick = function () {
      if (getWindowObj()) {
        getWindowObj().plausible('Claim Membership Pass Selected');
      }
    };
  }

  const element3: any = document.getElementsByClassName('button-5');
  if (element3) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < element3.length; i++) {
      element3[i].onclick = function () {
        toggleLearnMoreClass();
      };
    }
  }

  const element4: any = document.getElementsByClassName('imo');
  if (element4 && element4.length) {
    element4[0].onclick = function () {
      toggleLearnMoreClass();
    };
  }

  const switchComponent: any =
    document.getElementsByClassName('switch-component');
  if (switchComponent && switchComponent.length > 0) {
    const element5 = switchComponent[0].children;
    if (element5 && element5.length > 1) {
      const part1: any = document.getElementsByClassName('part-1');
      const part2: any = document.getElementsByClassName('part-2');
      element5[0].onclick = function () {
        part1[0].style.display = 'flex';
        part2[0].style.display = 'none';
        element5[0].style.borderColor = 'rgb(255, 255, 255)';
        element5[0].style.color = 'rgb(255, 255, 255)';

        element5[1].style.borderColor = 'rgba(0, 0, 0, 0)';
        element5[1].style.color = 'rgb(176, 177, 169)';
      };
      element5[1].onclick = function () {
        part1[0].style.display = 'none';
        part2[0].style.display = 'flex';
        element5[1].style.borderColor = 'rgb(255, 255, 255)';
        element5[1].style.color = 'rgb(255, 255, 255)';

        element5[0].style.borderColor = 'rgba(0, 0, 0, 0)';
        element5[0].style.color = 'rgb(176, 177, 169)';
      };
    }
  }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const setBodyClass = (cls: string) => {
  const body = document.getElementsByTagName('body');
  if (body && body.length) {
    body[0].classList.add(cls);
    addNavbarEvent();
    addEventForPlausibleClick();
  }
};

export const removeLoader = () => {
  setTimeout(() => {
    const studioLoading = document.getElementById('studio-loading');
    if (studioLoading) {
      studioLoading.classList.remove('studio-loading');
    }
  }, 3000);
};

export const insertIframe = () => {
  const meetingsDiv = document.querySelector('.meetings-iframe-container');
  if (meetingsDiv) {
    const calendarUrl = meetingsDiv.getAttribute('data-src');
    const iframe = document.createElement('iframe');
    iframe.src = calendarUrl;
    iframe.width = '350px';
    iframe.height = '700px';
    iframe.style.border = 'none';
    iframe.style.overflow = 'hidden';
    meetingsDiv.parentNode?.replaceChild(iframe, meetingsDiv);
  }
};
